import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import Ad, { AdTypes } from '~/containers/AdContainer/AdContainer';
import Layout from '~/components/Layout/Layout';
import MetaTags from '~/components/MetaTags/MetaTags';
import NotFound from '~/components/NotFound/NotFound';
import SeasonStats from '~/components/SeasonStats/SeasonStats';
import TeamBanner from '~/components/TeamBanner/TeamBanner';

import withState from '~/hocs/withState';

import { initStore } from '~/state/store';
import { operations as teamOperations } from '~/state/team';

import { getTeamStats } from '~/util/getTeamData';

import find from 'lodash/find';
import get from 'lodash/get';
import includes from 'lodash/includes';

import css from '~/static/css/pages/team_stats.css';

const getTeamIdFromState = state => get(state, 'teamData.data.id', '');
const getTeamFromState = state => get(state, 'teamData.data', {});

class TeamStatsPage extends React.Component {
  static async getInitialProps(props) {
    const leagueSlug = props.query.leagueSlug;
    const teamId = parseInt(props.query.teamId, 10);

    let team = null;

    if (getTeamIdFromState(props.store.getState()) !== teamId) {
      team = await props.store.dispatch(teamOperations.setTeam(leagueSlug, teamId));

      if (!team || includes(team.api_uri, '/error/events')) {
        // eslint-disable-next-line
        props.res.statusCode = 404;
        return {
          leagueSlug,
          teamId,
          teamStats: [],
        };
      }
    } else {
      team = getTeamFromState(props.store.getState());
    }

    const teamStatsData = await getTeamStats(team.resource_uri).then(result =>
      get(result, 'leagues_team_stats', [])
    );

    const teamStats = get(
      find(teamStatsData, stat => stat.league.slug === leagueSlug),
      'seasons_team_stats[0].stats_groups',
      []
    );

    return {
      leagueSlug,
      teamId,
      teamStats,
    };
  }

  render() {
    const { leagueSlug, team, teamStats } = this.props;

    const columns = leagueSlug === 'nba' ? 'col-xs-12' : 'col-xs-12 col-md-6';

    if (!team || includes(team.api_uri, '/error/events') || !teamStats) {
      return <NotFound leagueSlug={leagueSlug} />;
    }

    return (
      <Layout>
        <Head>
          <style dangerouslySetInnerHTML={{ __html: css.stylesheet }} />
        </Head>
        <MetaTags content={team} type="team" />
        <div className={css.desktopView}>
          <Ad leagueSlug={leagueSlug} adType={AdTypes.LEADERBOARD} />
        </div>
        <TeamBanner team={team} currentSection="stats" />
        <div className={`row ${css.statContainer}`}>
          {teamStats.map(stat => (
            <div key={stat.name} className={`${columns} ${css.statBox}`}>
              <div className={css.statTitle}>{stat.name}</div>
              <SeasonStats stats={stat.stats} />
            </div>
          ))}
        </div>
      </Layout>
    );
  }
}

TeamStatsPage.displayName = 'TeamStatsPage';

TeamStatsPage.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  teamStats: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  team: state.teamData.data,
});

export default withState({ createStore: initStore, mapStateToProps })(TeamStatsPage);
